import React, { ComponentProps, memo, useMemo, useState } from "react";
import type ResponsiveImage from "./responsive-image.ts";
import { screenWidths } from "../../utils/screen-widths.ts";

type BareResponsiveImageProps = {
  image: ResponsiveImage;
  desktopWidth?: string;
  mobileWidth?: string;
} & ComponentProps<"img">;

const BareResponsiveImage: React.FC<BareResponsiveImageProps> = memo(
  ({ image, desktopWidth = "100vw", mobileWidth = "100vw", ...props }) => {
    const placeholderImageUrl = "/static/images/image-placeholder.png";
    const [hasError, setHasError] = useState(false);

    const smallestImageUrl = useMemo(
      () =>
        image.sources.length > 0
          ? image.sources.reduce((min, s) => (s.width < min.width ? s : min), image.sources[0]).url
          : placeholderImageUrl,
      [image.sources],
    );

    const srcSet = useMemo(
      () => image.sources.map((s) => `${s.url} ${s.width.toString()}w`).join(", "),
      [image.sources],
    );

    return (
      <img
        src={hasError ? placeholderImageUrl : smallestImageUrl}
        sizes={`(max-width: ${screenWidths.md}) ${mobileWidth}, ${desktopWidth}`}
        srcSet={hasError ? undefined : srcSet}
        alt={image.altText}
        onError={() => setHasError(true)}
        {...props}
      />
    );
  },
);
BareResponsiveImage.displayName = "BareResponsiveImage";
export default BareResponsiveImage;
